import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import {
  Credentials,
  UserData,
  TokenAPI,
  ValidateTokenResponse,
  UserRegister,
  AppLoginInfoResponse,
} from '../_models/auth.models';
import { Observable, of } from 'rxjs';
import { environment } from 'src/environments/environment';
import { CONTENT_TYPES } from 'src/app/shared/constants';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private baseURL = '/api';
  private LOGIN_URL = '/user/login';
  private USER_EXIST = '/user/userExists';
  private AUTH0_LOGOUT = '/user/external/logout';
  private TOKEN_URL = '/token';

  constructor(private http: HttpClient) {}

  /**
   * Make headers
   */
  makeHeaders = (
    contentType: string = CONTENT_TYPES.APPLICATION_JSON,
    otp: string = ''
  ) => {
    let headers = new HttpHeaders();
    headers = headers.append('content-type', contentType);
    if (otp != '') {
      headers = headers.append('X-OTP', otp);
    }
    return headers;
  };

  /**
   * Get access token
   * @param payload credentials
   */
  token = (payload: Credentials, serverUrl: string = environment.apiUrl): Observable<TokenAPI> => {
    let params = new HttpParams();
    for (const creds in payload) params = params.set(creds, creds == "username" ? encodeURIComponent(payload[creds]) :  payload[creds]);
    if (!payload?.password) params = params.set('password', ' ');
    return payload?.x_otp == null
      ? this.http.post<TokenAPI>(
          `${serverUrl}${this.TOKEN_URL}`,
          params,
          {
            headers: this.makeHeaders(CONTENT_TYPES.URLENCODED),
          }
        )
      : this.http.post<TokenAPI>(
          `${serverUrl}${this.TOKEN_URL}`,
          params,
          {
            headers: this.makeHeaders(CONTENT_TYPES.URLENCODED),
          }
        );
  };

  /**
   * Login user and get roles, rights, userid etc
   * @param payload
   */
  login = (payload: Credentials): Observable<any> => {
    let params = new HttpParams();
    params = params.set('Email', encodeURIComponent(payload.username));
    params = params.set('PasswordHash', payload.password!);
    params = params.set(
      'GoogleRecaptchaTokenV3',
      payload.GoogleRecaptchaTokenV3!
    );
    return payload.x_otp == null
      ? this.http.post<any>(
          `${environment.apiUrl}${this.baseURL}${this.LOGIN_URL}`,
          params,
          {
            headers: this.makeHeaders(CONTENT_TYPES.URLENCODED),
          }
        )
      : this.http.post<any>(
          `${environment.apiUrl}${this.baseURL}${this.LOGIN_URL}`,
          params,
          {
            headers: this.makeHeaders(CONTENT_TYPES.URLENCODED, payload.x_otp),
          }
        );
    //{ headers: { 'X-OTP': loginData.oneTimePassword }
  };

  /**
   * Validate registeration Token
   * @param payload
   */
  validateToken = (payload: string): Observable<ValidateTokenResponse> => {
    return this.http.get<ValidateTokenResponse>(
      `${environment.apiUrl}${this.baseURL}/user/validatetoken?token=${payload}`
    );
  };

  /**
  * Get App Login Info
  * @param payload
  */
  appLoginInfo = (payload: string): Observable<AppLoginInfoResponse> => {
    return this.http.get<ValidateTokenResponse>(
      `${environment.apiUrl}${this.baseURL}/application/applogininfo?appId=${payload}`
    );
  };

  /**
   * Revoke refresh token
   * @param payload
   * @returns
   */
  revokeToken = (payload: string, headers: HttpHeaders): Observable<any> => {
    return this.http.get<any>(
      `${environment.apiUrl}${this.baseURL}/user/logout?token=${payload}`,
      {
        headers: headers,
      }
    );
  };

  /**
   * Register User
   * @param payload
   */
  registerUser = (payload: UserRegister): Observable<any> => {
    return this.http.post<any>(
      `${environment.apiUrl}${this.baseURL}/user/register`,
      payload
    );
  };
  /**
   * Check User Exist
   * @param payload
   */
  checkUserExist = (payload: UserRegister): Observable<any> => {
    return this.http.post<any>(
      `${environment.apiUrl}${this.baseURL}${this.USER_EXIST}`,
      payload
    );
    // return of(true);
  };

  /**
   * Check User Exist
   * @param payload
   */
  logoutfromAuth0 = (): Observable<any> => {
    return this.http.get<any>(
      `${environment.apiUrl}${this.baseURL}${this.AUTH0_LOGOUT}`
    );
    // return of(true);
  };
  
}
